<template>
  <div>
    <b-card no-body>
      <b-row class="mx-0" align-h="between" align-v="center">
        <b-col class="px-0" lg="4" md="12" sm="12">
          <h5>Related Events</h5>
        </b-col>
      </b-row>
      <b-table
        id="threat-log-table"
        class="table-with-actions-min-height"
        responsive
        small
        primary-key="id"
        :items="events"
        :fields="tableFields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortAsc"
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
      >
        <template #cell(severity)="row">
          <b-badge pill :variant="alertStatusVariant(row.value)">
            {{ alertStatusText(row.value)}}
          </b-badge>
        </template>
        <template #row-details="row">
          <ThreatFlowsTable
            v-if="row.item._showDetails"
            :start="item.firstSeen"
            :end="item.lastSeen"
            :ip="item.ip"
            :signatureId="row.item.signatureId"
          ></ThreatFlowsTable>
      </template>
      </b-table>
      <b-pagination
        v-if="paginationTotalRows > perPage"
        v-model="currentPage"
        :total-rows="paginationTotalRows"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
        align="right"
        class="mb-0 mt-1"
        ariaControls="threat-log-table"
      ></b-pagination>
      <b-card-body class="pt-2">
        <ThreatRelatedEvidenceTable
          v-if="enrichments.length"
          :enrichments="enrichments"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>

import alertSeverities from '@/xvisor/constants/alertSeverities';
import colorPalette from '@/xvisor/constants/colorPalette';
import ThreatFlowsTable from '@/xvisor/components/security/ThreatFlowsTable.vue';
import ThreatRelatedEvidenceTable from '@/xvisor/components/security/ThreatRelatedEvidenceTable.vue';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    ThreatFlowsTable,
    ThreatRelatedEvidenceTable,
  },
  data() {
    return {
      events: [],
      enrichments: [],
      perPage: 5,
      currentPage: 1,
      tableFields: [
        { key: 'severity', label: 'Severity', sortable: true },
        { key: 'signature', label: 'Signature', sortable: true },
        { key: 'count', label: 'Count', sortable: true },
        { key: 'techniqueId', label: 'MITRE Technique ID', sortable: true },
      ],
      colorPalette,
      sortBy: 'severity',
    };
  },
  mounted() {
    this.httpGet();
  },
  computed: {
    eventTableUrl() {
      return `/alerts/${this.item.ip}/events.json`;
    },
    paginationTotalRows() {
      return this.events.length;
    },
  },
  methods: {
    httpGet() {
      this.$http
        .get(this.eventTableUrl, {
          params: {
            start: this.item.firstSeen,
            end: this.item.lastSeen,
          },
        })
        .then((response) => {
          const payload = Array.isArray(response.data) ? response.data[0] : response.data;
          this.events = (payload.suricataLogAgg || []).map((row) => ({ ...row, _showDetails: false }));
          this.enrichments = [{ ipThreatEnrichments: payload.ipThreatEnrichments || {} }];
        });
    },
    alertStatusVariant(status) {
      if (status === alertSeverities.critical) return 'danger';
      if (status === alertSeverities.warning) return 'warning';
      return 'success';
    },
    alertStatusText(status) {
      if (status === alertSeverities.critical) return 'Critical';
      if (status === alertSeverities.warning) return 'Warning';
      return 'Notice';
    },
    onRowSelected(selectedItems) {
      this.events.forEach((row) => {
        this.$set(row, '_showDetails', false);
      });
      if (selectedItems.length === 1) {
        const row = selectedItems[0];
        this.$set(row, '_showDetails', true);
        this.selected = row;
      } else {
        this.selected = null;
      }
    },
  },
};
</script>
